import { sectionTitleTextStyles } from 'pages/our-story/OurStoryPage'
import { Section6Images } from '../../../assets/OurStoryImages/Section6'

import Slider from 'react-slick'
import { SlideImage } from 'pages/our-story/components/SlideImage'

const slideStyles = 'h-[60px] border-x-4 border-transparent mx-auto'

export const Section6 = () => {
  const settings = {
    centerMode: false,
    centerPadding: '0px',
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 250,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
  }

  return (
    <div className='!py-10 !px-5 bg-[#ebf3ff] lg:!px-30'>
      <div className='py-6'>
        <h1 className={`${sectionTitleTextStyles} text-center mb-10`}>
          We have worked with
        </h1>
        <Slider {...settings} className='bg-white py-3 border border-[#cce3ff]'>
          <SlideImage src={Section6Images.partner1} />
          <SlideImage src={Section6Images.partner2} />
          <SlideImage src={Section6Images.partner3} />
          <SlideImage src={Section6Images.partner4} />
          <SlideImage src={Section6Images.partner5} />
          <SlideImage src={Section6Images.partner6} />
          <SlideImage src={Section6Images.partner7} />
          <SlideImage src={Section6Images.partner8} />
          <SlideImage src={Section6Images.partner9} />
          <SlideImage src={Section6Images.partner10} />
          <SlideImage src={Section6Images.partner11} />
          <SlideImage src={Section6Images.partner12} />
          <SlideImage src={Section6Images.partner13} />
          <SlideImage src={Section6Images.partner14} />
          <SlideImage src={Section6Images.partner15} />
          <SlideImage src={Section6Images.partner16} />
          <SlideImage src={Section6Images.partner17} />
          <SlideImage src={Section6Images.partner18} />
          <SlideImage src={Section6Images.partner19} />
        </Slider>
      </div>
    </div>
  )
}
